import { render } from "./LogisticsList.vue?vue&type=template&id=e53f8d34&scoped=true"
import script from "./LogisticsList.vue?vue&type=script&lang=js"
export * from "./LogisticsList.vue?vue&type=script&lang=js"

import "./LogisticsList.vue?vue&type=style&index=0&id=e53f8d34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e53f8d34"]])

export default __exports__